document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll('.product-card__image-wrapper');

  let delay = 0;

  items.forEach((item) => {
    setTimeout(() => {
      item.classList.add('product-pop-in');
    }, delay);
    delay += 120;
  });
});
